import { render } from "./DocumentReportExports.vue?vue&type=template&id=0c0eb5ca&scoped=true&ts=true"
import script from "./DocumentReportExports.vue?vue&type=script&lang=ts"
export * from "./DocumentReportExports.vue?vue&type=script&lang=ts"

import "./DocumentReportExports.vue?vue&type=style&index=0&id=0c0eb5ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0eb5ca"]])

export default __exports__